/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import isString from"./isString";const encodeHTML=function(e){isString(e)||(e=`${e}`);let r="";return 0===e.length?"":(r=e.replace(/&/g,"&amp;"),r=r.replace(/</g,"&lt;"),r=r.replace(/>/g,"&gt;"),r=r.replace(/ /g,"&nbsp;"),r=r.replace(/'/g,"'"),r=r.replace(/"/g,"&quot;"),r=r.replace(/\n/g,"<br>"),r)};export default encodeHTML;